// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';
import CreateAction from '../operational/createAction';
import MyInput from './MyInput';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { emailValidator } from '../../helper/Validators';
import { translate } from '../../utils/language';
const ChangePassword = ({ setPage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [password, setPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [isChangedPassword, setIsChangedPassword] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const [email, setEmail] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.t) {
      setResetToken(params.t);
    } else {
      navigate('/login');
    }
  }, []);
  const handleChangePassword = async () => {
    // if (!emailValidator(email)) {
    //   return dispatch(systemSlice.actions.setToastError({ detail: translate("missingEmail") }))
    // }

    if (!resetToken) {
      return dispatch(systemSlice.actions.setToastError({ detail: 'Token boş olamaz.' }));
    }
    if (!password) {
      return dispatch(systemSlice.actions.setToastError({ detail: 'Şifre boş olamaz.' }));
    }
    if (confirmNewPassword !== password) {
      return dispatch(systemSlice.actions.setToastError({ detail: 'Şifreler uyuşmuyor.' }));
    }
    const response = await CreateAction({
      method: 'post',
      path: '/sso/resetPassword',
      data: { password, resetToken },
      showPreLoader: true,
      isFileUploading: false,
    });
    if (response?.error) return setIsError(true);
    setIsChangedPassword(true);
    window.location.href = '/login';
  };

  const handleResetToken = value => {
    setResetToken(value);
  };

  const handleMail = value => {
    setEmail(value);
  };

  const handleNew = value => {
    setPassword(value);
  };

  const handleConfirmNew = value => {
    setConfirmNewPassword(value);
  };

  return (
    <>
      <p className="text-[#8A92A6] font-medium text-lg">Şifrenizi Değiştirin</p>
      <div className="w-[300px] sm:w-[500px] mt-7 gap-3 flex flex-col">
        {/* <MyInput placeholder={'Mail Adresi'} classes={' text-[#60646F]'} value={email} onChange={handleMail}></MyInput> */}
        {/* <MyInput
          placeholder={'Reset Token'}
          classes={' text-[#60646F]'}
          value={resetToken}
          onChange={handleResetToken}
          isDiasbled={true}
        ></MyInput> */}

        <MyInput
          type="password"
          placeholder={'Yeni Şifre'}
          classes={' text-[#60646F]'}
          value={password}
          onChange={handleNew}
        ></MyInput>
        <MyInput
          type="password"
          placeholder={'Yeni Şifreyi Onayla'}
          classes={`text-[#60646F]  `}
          value={confirmNewPassword}
          onChange={handleConfirmNew}
        ></MyInput>
        <PrimaryButton
          value={'Şifremi Güncelle'}
          classes={'py-4 my-2 rounded-full h-14 bg-[#6F66F6] transition duration-150'}
          onClick={handleChangePassword}
        />

        <div className="relative">
          <div className="relative flex justify-center">
            <span className="bg-white text-sm  font-normal text-[#8A92A6]">ya da</span>
          </div>
        </div>
        <div className="w-[300px] sm:w-[500px] display flex justify-center" onClick={() => navigate('/login')}>
          <div className="font-bold" style={{ cursor: 'pointer' }}>
            Ana Sayfaya Dön
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
